import script from "./buttonScroller.vue?vue&type=script&setup=true&lang=js"
export * from "./buttonScroller.vue?vue&type=script&setup=true&lang=js"

import "./buttonScroller.vue?vue&type=style&index=0&id=387be9f1&lang=css"

const __exports__ = script;

export default __exports__